function cfSevenValid() {
  if (document.querySelector(".wpcf7") !== null) {
    var wpcf7Elm = document.querySelector(".wpcf7");

    wpcf7Elm.addEventListener(
      "wpcf7mailsent",
      function (event) {
        if (
          document.body.classList.contains("properties-template-properties")
        ) {
          checkAndPushEvent("formSubmitRequestCall");
        }
        if (document.body.classList.contains("page-template-default")) {
          checkAndPushEvent("formSubmitContactUs");
        }
      },
      false
    );

    wpcf7Elm.addEventListener(
      "wpcf7invalid",
      function (event) {
        setTimeout(() => {
          var notVaildElems = wpcf7Elm.querySelectorAll(".wpcf7-not-valid");
          var notValidText = [];

          notVaildElems.forEach(function (item) {
            var getText = item.parentNode.previousSibling.innerHTML;
            notValidText.push(getText);
          });

          var conForMessage = wpcf7Elm.querySelector(".form-contact");
          var getCurMeassage = conForMessage.querySelectorAll(
            ".form-contact__message"
          );

          if (getCurMeassage.length != "") {
            getCurMeassage[0].innerHTML =
              "Incorrect " + notValidText.join(", ") + ".";
          } else {
            var messageEleme = document.createElement("p");
            conForMessage.append(messageEleme);
            messageEleme.classList.add(
              "form-contact__message",
              "form-contact__message_not-v"
            );
            messageEleme.innerHTML =
              "Incorrect " + notValidText.join(", ") + ".";
          }
        }, 500);
      },
      false
    );
  }
}

function checkAndPushEvent(eventToPush) {
  new Promise(function (resolve) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventToPush });
    console.log("event pushed:", eventToPush);
    resolve();
  }).then(function () {
    location = document.location.origin + "/thank-you-for-contacting-us/";
  });
}
module.exports = cfSevenValid;
